// OKKIO — Meta Pixel centralizzato, consent-gated (GDPR).
// Nessuno script/evento Meta prima del consenso COOKIE MARKETING.
// Il consenso è quello già gestito da CookieConsent; qui non si crea un secondo sistema.

const PIXEL_ID = "28395094300083907";
const PURCHASE_PREFIX = "okkio_fb_purchase_";
const QUOTE_PREFIX = "okkio_fb_quote_";

// Carica fbevents.js UNA SOLA VOLTA (lazy) e inizializza il pixel + PageView.
function loadPixelOnce() {
  if (window.__okkioFbqInited) return;
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.__okkioFbqInited = true;
  window.fbq("track", "PageView");
}

// Sincronizza lo stato Meta col consenso Marketing (chiamato dal CookieConsent).
export function applyMetaConsent(marketingAllowed) {
  try {
    window.__okkioMktAllowed = !!marketingAllowed;
    if (marketingAllowed) {
      // Se il consenso arriva dopo il load, inizializza ORA (una sola volta) + PageView.
      loadPixelOnce();
    }
    // Se rifiutato/revocato: nessun caricamento; gli eventi futuri sono bloccati dal guard.
  } catch { /* ignore */ }
}

function canTrack() {
  return !!window.__okkioMktAllowed && !!window.__okkioFbqInited && typeof window.fbq === "function";
}

export function metaTrack(event, params) {
  if (!canTrack()) return;
  try { params ? window.fbq("track", event, params) : window.fbq("track", event); } catch { /* ignore */ }
}

function metaTrackCustom(event, params) {
  if (!canTrack()) return;
  try { params ? window.fbq("trackCustom", event, params) : window.fbq("trackCustom", event); } catch { /* ignore */ }
}

// QuoteAnalyzed idempotente: 1 sola emissione per report/token (a prova di rerender/reload/polling).
export function metaQuoteAnalyzedOnce(key) {
  if (!key || !canTrack()) return;
  const storageKey = QUOTE_PREFIX + key;
  try {
    if (localStorage.getItem(storageKey)) return;
  } catch { /* se storage non disponibile, procedi comunque una volta */ }
  metaTrackCustom("QuoteAnalyzed");
  try { localStorage.setItem(storageKey, String(Date.now())); } catch { /* ignore */ }
}

export function metaInitiateCheckout() {
  metaTrack("InitiateCheckout");
}

// Purchase idempotente: 1 sola emissione per chiave (session/report), a prova di refresh/back-forward.
export function metaPurchaseOnce(key) {
  if (!key || !canTrack()) return;
  const storageKey = PURCHASE_PREFIX + key;
  try {
    if (localStorage.getItem(storageKey)) return;
    localStorage.setItem(storageKey, String(Date.now()));
  } catch { /* se storage non disponibile, procedi comunque una volta */ }
  metaTrack("Purchase", { value: 9.99, currency: "EUR" });
}
